<template>
<div>
  <page-padding>
    <spinner v-if="loading"/>

   
      <div v-if="!hasSlots &&!loading">{{$t('language.no_teacher_talks')}}</div>
    </page-padding>
    


    <div v-for="(item,index) in computedSlots" :key="index">
      <head-slots :title="item.date + ' '+ talk.name"/>
      
      <!-- kinderen verwacht -->
      <div v-if="computeUserAccess">
      <ul>
        <li class="planned-chip" v-for="(child) in talk.children" :key="child.time" v-html="getChildPlannedText(child)"></li>
      </ul>
    </div>

      <!-- time slots -->
     
      <page-padding>
          <div class="row">
            <div class="col-xs-6 col-sm-4 col-md-3" v-for="(slot,index) in item.slots" :key="index">
              <time-slot @input="getSelectedVal" :disabled="loading" :children="talk.children" :timeslot="slot" :key="item.contant+item.child_id"/>
            </div>
          </div>
      </page-padding>

    </div>

    <!--<ui-radio-group  @input="getSelectedVal">-->
    <!--</ui-radio-group>-->


</div>
</template>

<script>

import Vue from 'vue';
import { mapState } from 'vuex';
//import UiRadio from '../../components/UiRadio.vue';
//import UiRadioGroup from '../../components/UiRadioGroup.vue';
//import UiChip from '../../components/UiChip.vue';
import HeadSlots from '../../components/talks/HeadSlots.vue';
import { USER_LEVEL } from '../../settings/USER_LEVEL';
import { modalService } from '../../services/ModalService.js';
import PagePadding from '../../components/PagePadding.vue';
import Spinner from '../../components/Spinner.vue';
import TimeSlot from '../../components/talks/TimeSlot.vue';

export default {
  name: 'render-slots',
  props:{
   talk:{},
  },
  data(){
    return {
      //talk_id:undefined,
      store_key:undefined,
      //children:[],
      loading:false,
      //planned_count:0,
    }
  },
  computed:{
     ...mapState(['teacher_talks_slots','appSettings']),
     computeUserAccess(){
         if (this.appSettings.user_level==USER_LEVEL.PARENT){
           return true;
         }
         if (this.appSettings.user_level==USER_LEVEL.TEACHER){
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.STUDENT){
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.ADMIN){
           return false;
         }
         return false;
       },
       computedSlots(){
         
         return this.teacher_talks_slots[this.store_key]
       },
       hasSlots(){
         return this.teacher_talks_slots[this.store_key] ? this.teacher_talks_slots[this.store_key].length : 0;
       }
  },
  components:{
    //UiRadio,
    //UiRadioGroup,
    HeadSlots,
    PagePadding,
    //UiChip,
    Spinner,
    TimeSlot,
  },
  methods:{
    loadSlots(){

      // setting the store key to get multidimensional array data from store
      this.store_key=this.talk.group_id+this.talk.talk_id+"slot";
    
      var payload={
        store_key:this.store_key,
        group_id:this.talk.group_id,
        talk_id:this.talk.talk_id,
      }

     
      
      this.$store.dispatch('get_teacher_talks_slots',payload).then(()=>{
      
         this.loading=false;
      })

    },
    getSelectedVal(data){
      this.updateTalkSlot(data);
    },
    updateTalkSlot(_data){

      
      var data={
        store_key:this.store_key,
        group_id:this.talk.group_id,
        slot_id:_data.slot_id,
        child_id:_data.child_id,
      };

      this.$store.dispatch('update_teacher_talks_slot',data).then(
        result=>{
        
          if(result.data.error!=""){
            
            // was unable to make reservation... try another slot
            modalService.createAlert(this.$t("language.unable_talk_reserve"));
          }else{
            this.planned_count++;
            Vue.$toaster.toast("language.slot_updated")
          }
          // reload slots
          this.loadSlots();
           this.$emit('RELOAD_TALKS');
        }
      )
      
    },
    getChildPlannedText(child){
      
      if(child.time!="" && child.time && child.time!=null){
        
        return this.$t('language.you_are_expected_at')+" <b>" + child.time +"</b> "+this.$t('language.for')+" <b>"+ child.name +"</b>";
      }
      
      return "<span style='color:#F46767'>"+this.$t('language.talk_to_be_planned')+" <b>"+ child.name + "</b></span>";
    }
  },
  beforeDestroy(){
     this.$off('clicked-ui-radio',this.getTalks);
  },
  mounted(){
    
    this.loadSlots()
   
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


.slot{
  margin-bottom:10px;
  text-align:center;
  min-height:80px;
}
.subtitle{
  
  text-align:center;
}
.chip{
  text-align:center;
  cursor:pointer;
}



.subtitle::after{
  content:"\00a0"; /* &nbsp */
}
</style>
